import { render } from "./InvoiceSettingEdit.vue?vue&type=template&id=2a470944"
import script from "./InvoiceSettingEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceSettingEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__